import App from './App.svelte';
import { Config } from './types';

const htmlRoot = document.documentElement;
const locale = htmlRoot.getAttribute('lang');
const country = htmlRoot.getAttribute('data-country');
const directory = htmlRoot.getAttribute('data-directory') || country;

/**
 * Reads in the Translation file corresponding to the locale that was set in the html's lang attribute
 */
async function getTranslations(): Promise<Object> {
    return await import(`../translations/${locale}.json`).then((strings) => strings.default);
}

async function getConfigData(): Promise<Config> {
    return await import(`../${directory}/config.json`).then((strings) => strings.default);
}

async function getApiUrls(): Promise<Object> {
    return await import(`../${directory}/api.json`).then((strings) => strings.default);
}

Promise.all([getTranslations(), getConfigData(), getApiUrls()]).then(([translations, config, apiUrls]) => {
    new App({
        target: document.getElementById('app'),
        props: {
            i18n: translations,
            config: config,
            apis: apiUrls,
            lang: locale,
            country: country,
            directory: directory,
        },
    });
});
